import ScrollMagic from 'scrollmagic';
import 'ScrollMagicAddIndicators';

export default {
	init() {

		function GetInColumnsBox2( container ) {

			var magicContainer = container.querySelectorAll('.col__box');

			var controller = new ScrollMagic.Controller();

			magicContainer.forEach( function( container, index ){

				new ScrollMagic.Scene({triggerElement: container, triggerHook: 1 })
					// trigger animation by adding a css class
					.setClassToggle(container, "load")
					// .addIndicators({name: index+" - columnsBox2"}) // add indicators (requires plugin)
					.addTo(controller);

			});

		}

		var container = document.querySelectorAll('.columnsBox2');

		if( container.length == 1 ) {

			GetInColumnsBox2( container[0] );

		}
    
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
